export default "__VITE_ASSET__CpyVlkBa__"